
const CONSTANT = require('./constant')

export const BASE_URL = CONSTANT.BASE_URL

export const mode = typeof window !== 'undefined' && window.location.href.indexOf('#/') !== -1 ? 'hash' : 'history'

